import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { AtendimentoList } from '../../../atendimento/core/_models'
import { AtendimentosAsoDownloadColumns } from './columns/_columns'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const DownloadAsoTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => AtendimentosAsoDownloadColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum ASO encontrado'
      description='Revise o paciente, o protocolo ou a data.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum ASO finalizado'
      description='Os ASOs aparecem aqui depois de assinados e finalizados.'
    />
  )

  return (
    <CustomTable<AtendimentoList>
      id='kt_table_download_aso'
      ariaLabel='ASOs para baixar'
      itemLabel={{ singular: 'ASO', plural: 'ASOs' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
